import React from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  return <LandingPage data-id="element-0" data-mp="35ckao89f74ji" />;
}